import { API_URL } from "../config";

export const sistemaServices = {
  actualizarSistema: async (key: string): Promise<void> => {
    try {
      const response = await fetch(`${API_URL}/sistema/actualizar`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-API-Key": key,
        },
      });
      if (!response.ok) {
        throw new Error("Error al actualizar el sistema");
      }
    } catch (error) {
      console.error("Error al actualizar el sistema:", error);
      throw error;
    }
  },
};
